<template>
    <b-modal
        v-model="isVisible"
        modal-class="sort-update-wrapper vue-need-bootstrap"
        title="Sorting update"
        title-class="h5 font-weight-bold"
        lazy
        centered
        no-close-on-backdrop
        no-close-on-esc
        size="md"
        @close="onCloseHandler"
        @cancel="onCloseHandler"
        @ok="onConfirmHandler"
    >
        <div class="content">
            <p class="text-content">This sorting update will impact all options linked to this library.</p>
        </div>

        <template #modal-footer="{ ok, cancel }">
            <div class="d-flex justify-content-center">
                <c-button size="sm" text="Cancel" variant="outline-primary" @click="cancel()" />
                <c-button text="confirm" size="sm" variant="primary" class="ml-1 m-0" @click="ok()" />
            </div>
        </template>
    </b-modal>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import CButton from './shared/CButton';

const props = defineProps<{
    onCancel?: () => void;
    onConfirm?: () => void;
}>();

const isVisible = ref(true);

const onCloseHandler = () => {
    props.onCancel?.();
};

const onConfirmHandler = () => {
    props.onConfirm?.();
};
</script>

<style scoped lang="scss">
.text-content {
    color: #333;
    font-family: Helvetica;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
::v-deep .sort-update-wrapper {
    .chekbox-show {
        .custom-control-label {
            &::before,
            &::after {
                top: 0.1rem;
            }
        }
    }
}
</style>
